import { FormConfig, FormFieldType } from "../../../components/form/formTypes";

export default function trainingVersionFormConfig(
  topicOptions: Record<string, string>,
): FormConfig[] {
  return [
    {
      name: "title",
      label: "trainingVersion.field.title",
      placeholder: "trainingVersion.field.title",
      type: FormFieldType.Text,
    },
    {
      name: "description",
      label: "trainingVersion.field.description",
      placeholder: "trainingVersion.field.description",
      type: FormFieldType.Textarea,
    },
    {
      name: "isAvailable",
      label: "trainingVersion.field.isAvailable",
      type: FormFieldType.Switch,
    },
    {
      name: "topicIds",
      label: "trainingVersion.field.topicIds",
      placeholder: "trainingVersion.field.topicIdsPlaceholder",
      type: FormFieldType.MultiSelect,
      settings: {
        options: topicOptions,
      },
    },
    {
      name: "relatedTopicIds",
      label: "trainingVersion.field.relatedTopicIds",
      placeholder: "trainingVersion.field.relatedTopicIdsPlaceholder",
      type: FormFieldType.MultiSelect,
      settings: {
        options: topicOptions,
      },
    },
  ];
}
